import React from "react";
import PremiumSoftLogo from "../../assets/images/premium-soft.png";

import { Wrapper } from "./style";

function Logo() {
  return (
    <Wrapper>
      <span style={{ fontSize: "24px", width: "100px" }}>
        <img src={PremiumSoftLogo} alt="PremiumSoft" height="35px" />
      </span>
    </Wrapper>
  );
}

export default Logo;
